import React, { Component } from 'react';
import { string, bool } from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './CheckBox.css';

const icons = {
  'default': { icon: 'checkmark-12', type: 'other'},
  'table': { icon: 'half-check-12', type: 'other'},
  'withLabel': { icon: 'checkbox', type: '15'},
  'rounded': { icon: 'checkmark-14', type: 'other'}
};

class CheckBox extends Component {
  static propTypes = {
    disabled: bool,
    label: string,
    table: bool,
    error: string,
    darkBg: bool,
    defaultChecked: bool,
    rounded: bool,
    bgImage: string
  };

  state = { isChecked: false, hasError: false };

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.defaultChecked) {
      return {
        isChecked: !!nextProps.defaultChecked
      };
    }

    if (nextProps.error) {
      return {
        hasError: !!nextProps.error
      };
    }

    return null;
  }

  toggleChecked = () => {
    this.setState({ isChecked: !this.state.isChecked });
  }

  render() {
    const {
      darkBg,
      label,
      table,
      error,
      disabled,
      rounded,
      bgImage
    } = this.props;
    const { isChecked, hasError } = this.state;
    const cx = classnames.bind(styles);
    let imagePath;
    const inputFieldClasses = cx({
      inputField: true,
      withLabel: label,
      error: hasError,
      withImage: bgImage,
      table,
      rounded,
      darkBg,
    });

    const checkBoxType = label
      ? 'withLabel'
      : table ? 'table' : rounded ? 'rounded' : 'default'
    ;

    if (bgImage) {
      imagePath = require(`assets/images/flags/${bgImage}.png`); // TODO: should the fullPath be dynamic?
    }

    return (
      <div className={classnames('checkbox', inputFieldClasses)}>
        <input
          type='checkbox'
          disabled={disabled}
          checked={isChecked}
          className={styles.input}
          onClick={this.toggleChecked}
        />

        { this.state.isChecked && !bgImage ? <Icon {...icons[checkBoxType]} /> : null }

        { bgImage && <span style={{backgroundImage: `url(${imagePath})`}} className={styles.image}></span> }

        { label && <p className={styles.inputLabel}>{label}</p> }

        { hasError && <p className={`${styles.error} small`}>{error}</p> }
      </div>
    );
  }
}

export default CheckBox;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/CheckBox.js